import type { DestinationAudience } from "../types/destinations";

/**
 * Tells staff from clients for the signed-in profile.
 *
 * @param profile - The signed-in profile; `undefined` before sign-in.
 * @returns `practitioner` for a Practitioner profile, else `patient`, so any other profile sees only
 * the client-facing destinations.
 */
export function getDestinationAudience(
  profile: { resourceType: string } | undefined,
): DestinationAudience {
  return profile?.resourceType === "Practitioner" ? "practitioner" : "patient";
}
